import React from 'react';
import { formatNumber } from '~/utils/format';

import { NameAndRole, CustomTd } from '../components';

export const tableDataParser = ({ data, invert }) => {
  return data.map(item => {
    const isTop5 =
      item.isTop5InGoals ||
      item.isTop5InPasses ||
      item.isTop5InRecoveries ||
      item.isTop5InShots ||
      item.isTop5InAssists ||
      item.isTop5InSavesMade ||
      item.isTop5gamesPlayed;
    return {
      id: item.id,
      isTop5,
      namePosition: (
        <NameAndRole
          invert={invert}
          image={item.photo}
          name={item.nickname}
          rol={item.squadRoleFrontendSku}
          isTop5={isTop5}
        />
      ),
      goals: <CustomTd name={item.goals} isTop5={item.isTop5InGoals} />,
      passes: (
        <CustomTd
          name={formatNumber(item.totalPasses)}
          isTop5={item.isTop5InPasses}
        />
      ),
      recoveries: (
        <CustomTd name={item.recoveries} isTop5={item.isTop5InRecoveries} />
      ),
      shotsStops: (
        <CustomTd name={item.totalShots} isTop5={item.isTop5InShots} />
      ),
      assists: (
        <CustomTd name={item.goalAssists} isTop5={item.isTop5InAssists} />
      ),
      stops: <CustomTd name={item.savesMade} isTop5={item.isTop5InSavesMade} />,

      gamesPlayed: (
        <CustomTd name={item.gamesPlayed} isTop5={item.isTop5gamesPlayed} />
      ),
    };
  });
};
